import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Row,
  Col,
  Stack,
} from "react-bootstrap";
import "./Navbar.css"; // Import custom CSS
import { NavLink, useLocation } from "react-router-dom";
import MobileDrawer from "../../Drawer/Drawer";
import { useSelector } from "react-redux";
const CustomNavbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const userx = useSelector(state => state.user);

  const [open, setOpen] = useState(false);
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [affliateAddPermission, setAddAffliatePermisssion] = useState(false);
  const [commissionGroupPermission, setCommmissionGroupPermission] = useState(false);
  const [affliateGroupPermission, setAffliateGroupPermission] = useState(false);
  const [affliateReviewPermission, setAfffliateReviewPermisssion] = useState(false);
  const [userCreatePermisssion, setUserCreatePermisssion] = useState(false);
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  useEffect(() => {
    setAddAffliatePermisssion(checkPermission(affliate, "aff_add_affiliate"));
    setAfffliateReviewPermisssion(checkPermission(affliate, "aff_affiliate_review"));
    setUserCreatePermisssion(checkPermission(affliate, "set_add_user"));

  }, [affliate])
  const Logout = () => {
    localStorage.setItem("raff-token", null)
    dispatch({
      type: "SET_USER",
      data: {
        logged: false,
        user: null
      }
    })
    navigate("/")
  }
  return (
    <>
      <Container fluid className="nav-container pt-3 pb-3">
        <Row className="navbar-wrap" style={{ width: "90%", marginTop: "10px", marginLeft: "auto", marginRight: "auto" }}>
          <div style={{ width: "100%", display: "flex", padding: 12, alignItems : "center" }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", textAlign: "start", alignItems : "center" }}>
                <MobileDrawer />
                <div style={{ display : "flex", alignItems : "center" }}>
                  <img onClick={() => { window.location = "/dashboard"; }} style={{ width: 150 }} src={"/images/logo.png"} alt="Logo" />
                </div>
              </div>
            </div>
            <div style={{ justifyContent: "end", flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "end", marginRight: 10 }}>
                <div style={{ fontFamily: "Tahoma,Geneva,sans-serif" }} className="logout-btn-desktop">
                  <Button onClick={() => { Logout() }} style={{ minWidth: 170 }} className="custom-bg-warning text-dark me-2 rounded-0 w-50 border-0 fw-bold">
                    Logout
                  </Button>
                </div>
                <div className="profile-image me-2 mt-1 overflow-hidden">
                  <img style={{ width: "90%" }} src={require("../../../assets/flag_of_uk.png")} alt="Flag" />
                </div>
                <span style={{ fontWeight: 600 }} className="text-light  me-2 mt-2">EN</span>
              </div>
            </div>
          </div>
        </Row>
      </Container>


      <Navbar bg="" expand="lg" className="nav-container d-none d-lg-flex" style={{ fontSize: 16 }}>
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="text-light bg-light" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center" style={{ textAlign: "center" }}>
            <Nav style={{ height: 30 }} className="me-auto ms-auto d-flex justify-content-around w-100 ">
              <div style={{ width: "100%" }}>
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    isActive
                      ? "text-primary-xk fw-bold text-decoration-none"
                      : "text-light fw-bold hover-nav-item-colo text-decoration-none"
                  }
                >
                  Main Page
                </NavLink>
              </div>

              <div style={{ width: "100%", minWidth: 300 }} className="nav-item dropdown">
                <NavLink
                  className="text-light fw-bold hover-nav-item-color text-decoration-none"
                >
                  Work with affiliates
                </NavLink>
                <div className="dropdown-menu">
                  <NavLink
                    to="/affiliate/affliateliste"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Affiliate list
                  </NavLink>
                  {affliateAddPermission ? (

                    <NavLink
                      to="/affiliate/add-aff"
                      className="dropdown-item animated-box text-light text-decoration-none"
                    >
                      Add affiliate
                    </NavLink>) : (<></>)}
                  {affliateReviewPermission ? (
                    <NavLink
                      to="/affiliate/affreview"
                      className="dropdown-item animated-box text-light text-decoration-none"
                    >
                      Affiliate review
                    </NavLink>
                  ) : (<></>)}
                  <NavLink
                    to="/affiliate/commission-groups"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Commission groups
                  </NavLink>
                  <NavLink
                    to="/affiliate/aff-group"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Affiliate group
                  </NavLink>
                </div>
              </div>


              <div style={{ width: "100%" }} className="nav-item dropdown affmarketing">
                <NavLink
                  href="#more"
                  data-toggle="dropdown"
                  className="text-light fw-bold hover-nav-item-color text-decoration-none"
                >
                  Reports
                </NavLink>
                <div className="nav-item dropdown affmarketing dropdown-menu">
                  <NavLink
                    to="/affiliate/summary"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Summary
                  </NavLink>
                  <NavLink
                    to="/affiliate/full-report"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Full report
                  </NavLink>
                  <NavLink
                    to="/affiliate/promo-report"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Promo material report
                  </NavLink>
                  <NavLink
                    to="/affiliate/player-report"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Player report
                  </NavLink>
                </div>
              </div>
              <div style={{ width: "100%" }} className="nav-item dropdown affmarketing">
                <NavLink
                  data-toggle="dropdown"
                  className="text-light fw-bold hover-nav-item-color text-decoration-none"
                >
                  Marketing tools
                </NavLink>
                <div className="nav-item dropdown affmarketing dropdown-menu">
                  <NavLink
                    to="/affiliate/marketing/campaigns"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Campaigns
                  </NavLink>
                  <NavLink
                    to="/affiliate/marketing/list-media"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Media
                  </NavLink>
                </div>
              </div>
              <div style={{ width: "100%" }} className="nav-item dropdown affmarketing nav-item dropdown">
                <NavLink
                  data-toggle="dropdown"
                  className="text-light fw-bold hover-nav-item-color text-decoration-none "
                >
                  Payments
                </NavLink>
                <div className="nav-item dropdown affmarketing dropdown-menu">
                  <NavLink
                    to="/affiliate/payment/history"
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Payment history
                  </NavLink>
                  <NavLink
                    to='/affiliate/payment/user-invoices'
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Affiliate invoices
                  </NavLink>
                  <NavLink
                    to='/affiliate/payment/user-invoices-status'
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Affiliate invoices status
                  </NavLink>

                </div>
              </div>
              <div style={{ width: "100%" }} className="nav-item dropdown affmarketing">
                <NavLink
                  data-toggle="dropdown"
                  className="text-light fw-bold hover-nav-item-color text-decoration-none"
                >
                  Settings
                </NavLink>
                <div className="nav-item dropdown affmarketing dropdown-menu">
                  <NavLink
                    to='/affiliate/account-settings'
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Account settings
                  </NavLink>
                  {userCreatePermisssion ? (
                    <NavLink
                      to="/affiliate/settings/create-user"
                      className="dropdown-item animated-box text-light text-decoration-none"
                    >
                      Create user
                    </NavLink>) : (<></>)}
                  <NavLink
                    to='/affiliate/settings/user-list'
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    User list
                  </NavLink>
                  <NavLink
                    to='/affiliate/settings/mailing-templates'
                    className="dropdown-item animated-box text-light text-decoration-none"
                  >
                    Mailing Templates
                  </NavLink>
                  {
                      userx.User != null && userx.User.Permissions == null ? (
                        <NavLink
                          to='/affiliate/settings/variables'
                          className="dropdown-item animated-box text-light text-decoration-none"
                        >
                          Affiliate Variables
                        </NavLink>
                      ) : (
                          <></>
                      )
                  }
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default CustomNavbar;
